import * as React from 'react';
// import { LoaderWrapper } from './../../styles/settings';
import { LoaderContainer, OverlayContainer } from '../../styles/loader'

export default class LoaderComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = { open: '' }
    }

    componentWillReceiveProps(nextProps: any) {
        const isShowLoader = nextProps.sending ? true : false;
        if (isShowLoader !== this.props.sending) {
            this.setState({ open: isShowLoader })
        }  
    }

    closeNotification = () => {
        this.setState({ open: false })
    }

    render() {
        return (
            <LoaderContainer>
                {this.state.open ?
                    <div>  <OverlayContainer />
                        <div className="loader" /></div> : ''
                }
            </LoaderContainer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/loader.component.tsx